module.exports = __webpack_public_path__ + "static/media/team.0f0c65a0.svg";